import {bool, func, shape} from 'prop-types';
import Header from '../../shared/Header';
import AddressSection from '../house/AddressSection';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const ContactAddressBlock = ({
  contactAddressData,
  residenceData,
  handleChange,
  errors,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { same_as_house } = contactAddressData;
  const address = same_as_house ? residenceData : contactAddressData;
  const { HouseIcon } = useIconLibrary();

  return (
    <>
      <Header
        title={t("Contactadres")}
        icon={<HouseIcon height="2rem" width="2rem" />}
        variant="page"
      />
      <AddressSection
        {...{
          ...address,
          same_as_house,
          handleChange,
          errors,
          readOnly,
        }}
        isContactAddress
      />
    </>
  );
};

ContactAddressBlock.propTypes = {
  contactAddressData: shape({}),
  residenceData: shape({}),
  handleChange: func,
  errors: shape({}),
  readOnly: bool,
};

ContactAddressBlock.defaultProps = {
  contactAddressData: {},
  residenceData: {},
  errors: null,
  readOnly: true,
};

export default ContactAddressBlock;
